import React from 'react';
import 'components/newIdentifyMethods/video/VideoSelfieBiometricsChoice/VideoSelfieWithBiometricsLink/VideoSelfieWithBiometricsLink.scss';
import BiometricFace from 'assets/images/biometric-face.svg';
import FormattedTextWithComponents from 'components/FormattedTextWithComponents/FormattedTextWithComponents';
import { formatText } from 'core/i18n';

const VideoSelfieWithBiometricsLink = ({ onClick }) => {
    return (
        <div className="videoselfie-with-biometrics-link">
            <img src={BiometricFace} alt="biometric-face" />
            <FormattedTextWithComponents
                value="videoselfie-withBiometricsLinkMessage"
                injectedComponents={[
                    <span
                        key="videoselfie-withBiometricsLinkMessageLink"
                        role="button"
                        className="videoselfie-with-biometrics-link__link"
                        onClick={onClick}
                        tabIndex="0"
                        onKeyDown={onClick}
                    >
                        {formatText('videoselfie-withBiometricsLinkMessageLink')}
                    </span>,
                ]}
            />
        </div>
    );
};
export default VideoSelfieWithBiometricsLink;
